module.exports = __webpack_public_path__ + "static/media/ic_x.d1a5615f.svg";